module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout-page', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', {
    staticClass: "display-1 mb-3"
  }, [_vm._v("Seach results")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "scrollable": false
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_vm._l((_vm.tabs), function(tab) {
    return _c('v-tab', {
      key: tab.id,
      attrs: {
        "href": '#' + tab.id
      }
    }, [_vm._v(" " + _vm._s(tab.text) + "\n            ")])
  }), _vm._v(" "), _c('v-tab', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("youtube")])], 2), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab-item', {
    key: "meyouseek",
    attrs: {
      "id": "meyouseek",
      "transition": "",
      "reverse-transition": "",
      "lazy": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('meyouseek', {
    on: {
      "next": function($event) {
        _vm.active = 'youtube'
      }
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21567cd9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/SearchResults/PageSearchResults.vue
// module id = 349
// module chunks = 0